import { render, staticRenderFns } from "./ChangeDefaults.vue?vue&type=template&id=1b335594&"
import script from "./ChangeDefaults.vue?vue&type=script&lang=js&"
export * from "./ChangeDefaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports